/**
 * Shared overlay behaviour: body-scroll lock (ref-counted for stacking),
 * focus management, and a topmost-only overlay stack so Escape / focus-trap
 * only act on the front-most overlay when several are open at once.
 */

// ─── Body scroll lock (ref-counted) ──────────────────────────────────────────
let lockCount = 0
let savedOverflow = ''

export function lockScroll() {
  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }
  lockCount += 1
}

export function unlockScroll() {
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount === 0) document.body.style.overflow = savedOverflow
}

// ─── Overlay stack (only the topmost handles Escape / Tab) ────────────────────
const stack = []
export function pushOverlay(o) { stack.push(o) }
export function popOverlay(o) {
  const i = stack.indexOf(o)
  if (i >= 0) stack.splice(i, 1)
}
export function isTopOverlay(o) { return stack.length > 0 && stack[stack.length - 1] === o }

// ─── Focus helpers ────────────────────────────────────────────────────────────
const FOCUSABLE = [
  'a[href]', 'button:not([disabled])', 'input:not([disabled])',
  'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'
].join(',')

function focusableIn(root) {
  if (!root) return []
  return [...root.querySelectorAll(FOCUSABLE)].filter(el => el.offsetParent !== null)
}

export function focusFirst(root) {
  const items = focusableIn(root)
  if (items.length) items[0].focus()
  else if (root && root.focus) root.focus()
}

export function trapTab(e, root) {
  if (e.key !== 'Tab') return
  const items = focusableIn(root)
  if (!items.length) return
  const first = items[0]
  const last = items[items.length - 1]
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault()
    last.focus()
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault()
    first.focus()
  }
}
